export interface Size { w: number; h: number }

export const ZOOM_STEPS = [0.25, 0.33, 0.5, 0.67, 0.75, 1, 1.25, 1.5, 2, 3, 4];

/** Scale that fits a spread inside a viewport with padding on every side, in screen px per spread pt. */
export function fitScale(spread: Size, viewport: Size, padding = 24): number {
  const w = Math.max(1, viewport.w - padding * 2);
  const h = Math.max(1, viewport.h - padding * 2);
  if (spread.w <= 0 || spread.h <= 0) return 1;
  return Math.min(w / spread.w, h / spread.h);
}

export function fitWidthScale(spread: Size, viewport: Size, padding = 24): number {
  const w = Math.max(1, viewport.w - padding * 2);
  if (spread.w <= 0) return 1;
  return w / spread.w;
}

/** Next zoom step above or below the current scale. */
export function stepZoom(current: number, direction: 1 | -1): number {
  const eps = 1e-3;
  if (direction > 0) return ZOOM_STEPS.find((z) => z > current + eps) ?? ZOOM_STEPS[ZOOM_STEPS.length - 1];
  return [...ZOOM_STEPS].reverse().find((z) => z < current - eps) ?? ZOOM_STEPS[0];
}

/** Client (screen) coordinates to spread points, given the SVG element's client rect and the current scale. */
export function clientToSpread(clientX: number, clientY: number, svgRect: { left: number; top: number }, scale: number): { x: number; y: number } {
  return { x: (clientX - svgRect.left) / scale, y: (clientY - svgRect.top) / scale };
}

export const round2 = (n: number): number => Math.round(n * 100) / 100;
